import EntityValidationResult from 'modules/base/dto/validation/EntityValidationResult';
import nBossConnection from 'modules/base/service/nBossConnection';

class VizsgaFeladatsorService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'vizsgafeladatsorControl';
	}

	/**
	 * @param {string[]} questions
	 * @param {number} workbookId
	 * @return {Promise<Object>}
	 */
	checkQuestions(questions, workbookId) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/checkQuestions`, { questions, workbookId })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @param {number} vsorId
	 * @return {Promise<Object>}
	 */
	lockZeroPermutation(vsorId) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/lockZeroPermutation`, { vsor_id: vsorId })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @param {number} vsorId
	 * @return {Promise<Object>}
	 */
	generatePermutation(vsorId) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/generatePermutation`, { vsor_id: vsorId })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @param {number} vsorId
	 * @return {Promise<Object>}
	 */
	recalculateAfterDelete(vsorId) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/recalculateAfterDelete`, { vsor_id: vsorId })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}
}

export default new VizsgaFeladatsorService();
